import type { TRequiredValidatorParams } from '@ballerine/common';

import type { TValidator } from '../../types';

export const requiredValueValidator: TValidator<unknown, TRequiredValidatorParams> = (
  value,
  params,
) => {
  const { message = 'Required value.' } = params;

  if (value === undefined || value === null || value === '') {
    throw new Error(message);
  }
};
